<template>
        <div v-if="gelen.hataVarMi">
            {{gelen.mesaj}}
        </div>
        <div v-else class="belge-container">
            <div class="form-alani">
                <b-form @submit="Kaydet" method="post" autocomplete="off">
                    <div style="margin-bottom: 10px;">
                        <b-button class="ml-1" title="Yazı Boyutunu Azalt" @click="changeFontSize(-1)" size="sm"
                                  variant="outline-info">
                            A
                            <b-icon icon="dash"/>
                        </b-button>
                        <b-button title="Yazı Boyutunu Artır" @click="changeFontSize(1)" size="sm"
                                  variant="outline-info">
                            A
                            <b-icon icon="plus"/>
                        </b-button>
                        <b-button class="btn btn-danger float-right" @click="belgeIadeModalAc">Belgeyi İade Et
                        </b-button>

                        <b-modal id="modal-1"
                                 ref="belgeIadeModal"
                                 title="Belge İade İşlemi"
                                 cancel-title="Vazgeç"
                                 @cancel="iadeVazgeceTikladi"
                                 @ok="belgeIadeTalebiGonder"
                                 ok-title="Gönder">
                            <h5 class="font-weight-bold mb-3">Belgeyi Neden İade Etmek İstiyorsunuz?</h5>
                            <b-form-select
                                    v-model="belgeIadeSebebi"
                                    size="md"
                                    value-field="name"
                                    text-field="name"
                                    :options="iadeSebepler"
                            />
                        </b-modal>
                        <b-button class="float-right" v-b-toggle.collapse-1 variant="info">Durum</b-button>
                        <b-collapse id="collapse-1" class="mt-2">
                            <b-card>
                                <p class="card-text">Durum:
                                    <strong>{{intToDurumString(this.gelen.data.Durum.deger)}}</strong></p>
                                <p class="card-text">Editor İşlemi: <strong>{{intToIslemString(this.gelen.data.EditorIslem.deger)}}</strong>
                                </p>
                                <p class="card-text">Operatör İşlemi: <strong>{{intToIslemString(this.gelen.data.OperatorIslem.deger)}}</strong>
                                </p>
                            </b-card>
                        </b-collapse>
                    </div>

                    <div v-if="kisi.kartEditor" class="d-flex justify-content-between">
                        <p>
                            <a :href="'belgeler?tur=kart&id=' + gelen.data.OperatorKisi.deger.kisiId">{{isimGetir(gelen.data.OperatorKisi.deger.isim)}} </a>
                            / {{isimGetir(gelen.data.EditorKisi.deger.isim)}}
                        </p>
                        <!--Kart onaya gönderilmişse ve editor de atanmamışsa bu buton aktif olur. -->
                        <b-button v-if="gelen.data.Durum.deger === 4 && gelen.data.EditorKisiId.deger === 0 && gelen.data.OperatorKisiId.deger !== $store.getters.kisi.kisiId" @click="belgeninEditoruOlma">
                            Belgenin Editörü Ol
                        </b-button>
                    </div>
                    
                    <kamp-teklif-form />

                    <b-form-group v-for="(item, index) in kart" :key="index"
                                  :label="item.baslik" :label-for="index">
                        <imla v-if="item.imlaGoster && lastFocusedElement === index" @karakter-yaz="karakterYaz"/>

                        <div v-if="item.otomatikTamamlama">
                            <div v-if="index === 'KampId'">

                                <v-select
                                        :options="kamplar"
                                        label="value"
                                        :value="kampString"
                                        @input="kampSecildiginde"
                                        @search="kampListeleriniOner">
                                    <span slot="no-options">
                                    </span>
                                </v-select>

                                <b-button
                                        class="float-right"
                                        size="sm" v-b-modal.yeniKampTeklif>TEKLİF ET</b-button>
                                <div style="clear:both;"></div>
                            </div>

                            <div v-else>
                                <vue-simple-suggest
                                        @focus="onElementFocus(index)"
                                        v-model="giden[index]"
                                        :ref="index" :name="index" :id="index"
                                        :min-length=1
                                        :debounce=500
                                        :style="{ fontSize: (16 + fontSizeFactor) + 'px' }"
                                        :max-suggestions=10
                                        :list="() => oneriListesiniGetir(index)"
                                />
                            </div>
                        </div>

                        <div v-else>
                            <div v-if="item.key === 'BelgeDili'">
                                <b-form-select v-model="giden[index]"
                                               :options="belgeDiliListesi">

                                </b-form-select>
                            </div>

                            <div v-else>
                                <div v-if="item.inputType === 'number'">
                                    <b-form-input
                                            :style="{ fontSize: (16 + fontSizeFactor) + 'px' }"
                                            @focus="onElementFocus(index)"
                                            :type="item.inputType"
                                            :name="index" :id="index" v-model.number="giden[index]"/>
                                </div>
                                <div v-else>
                                    <textarea
                                            :style="{ fontSize: (16 + fontSizeFactor) + 'px' }"
                                            class="w-100"
                                            @focus="onElementFocus(index)"
                                            :type="item.inputType"
                                            :ref="index" :name="index" :id="index" v-model="giden[index]"/>
                                </div>
                            </div>

                        </div>
                    </b-form-group>


                    <b-form-checkbox v-if="this.gelen.data.Durum.deger===3" switch name="tamamlandi" id="tamamlandi"
                                     v-model="tamamlandi">
                        Onaya Gönder
                    </b-form-checkbox>
                    <b-form-checkbox v-if="this.gelen.data.Durum.deger===2" switch name="tamamlandi" id="tamamlandi"
                                     v-model="tamamlandi">
                        Tamamla
                    </b-form-checkbox>

                    <br style="margin: 30px"/>
                    <b-button
                            v-if="(this.kisi.kisiId===this.operatorKisiId && this.editorKisiId===0 ) || this.kisi.kisiId===this.editorKisiId"
                            block @click="Kaydet" variant="success">Kaydet
                    </b-button>
                    <b-button v-else>Kayıt Yetkiniz Yok</b-button>
                    <br style="margin: 30px"/>
                </b-form>
            </div>
            <div class="mektup-alani">
                <cropper :img="imgEkstraUrl" @sendCropDetails="okunamayanKelimeEkle"/>
            </div>
        </div>
</template>

<script>
    import {ShowSuccessModal} from "@/utils/messages"
    import {kartGetir, kartIade, kartinEditoruOl, kartKaydet, kartResmiGetir} from "@/api/kart"
    import Cropper from "@/components/Cropper"
    import {mapGetters} from "vuex"
    import {getFontSizeFactor, setFontSizeFactor} from "@/utils/cookie"
    import Imla from "@/components/Imla"
    import VueSimpleSuggest from 'vue-simple-suggest'
    import 'vue-simple-suggest/dist/styles.css'
    import {GoogleTokenIleGirisYapmayiDene} from "@/utils/googlegiris";
    import {idyeGoreKampiGetir, kamplariGetir} from "@/api/kamp";
    import {OtomatikTamamlama} from "@/api/autoComplete";
    import {okunmayanKelimeEkle} from "@/api/okunamayan";
    import {utilsMixin} from "@/utils/utilsMixin";
    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';
    import _ from 'lodash'
    import KampTeklifForm from "@/components/KampTeklifForm"

    export default {
        mixins: [utilsMixin],
        name: "kart",
        data() {
            return {
                kampString: '',
                kamplar: [],
                operatorKisiId: 0,
                editorKisiId: 0,
                tamamlandi: false,
                kart: {},
                gelen: {
                    hataVarMi: true,
                    mesaj: "Yükleniyor"
                },
                giden: {},
                lastFocusedElement: 'none',
                imgEkstraUrl: '',
                fontSizeFactor: 0,
            }
        },
        computed: {
            ...mapGetters([
                'bkCount', 'kisi', 'girisYapmismi'
            ]),
            belgeDiliListesi() {
                return [
                    {value: 'Osmanlıca', text: 'Osmanlıca'},
                    {value: 'Rusça', text: 'Rusça'},
                    {value: 'Fransızca', text: 'Fransızca'},
                    {value: 'İngilizce', text: 'İngilizce'},
                    {value: 'Diğer', text: 'Diğer'}
                ]
            }
        },
        methods: {
            async belgeninEditoruOlma() {
                const kartId = this.gelen.data.Id.deger;
                const response = await kartinEditoruOl(kartId);
                
                if (response.kod === "yetki.yok") {
                    this.$notify({
                        group: 'ust',
                        type: 'error',
                        title: 'Hata',
                        text: response.mesaj
                    });
                } else {
                    this.$notify({
                        group: 'ust',
                        type: 'success',
                        title: 'Başarılı',
                        text: "İşleminiz başarılı bir şekilde gerçekleştirildi.",
                        duration: 2000
                    });
                    setTimeout(() => {
                        window.location.reload();
                    }, 1500)    
                }
            },
            async belgeIadeTalebiGonder() {
                const res = await kartIade(this.gelen.data.Id.deger, this.belgeIadeSebebi)
                this.belgeIadeSonucKontrol(res,"kart")
            },
            kamplistesiSec(suggest) {
                this.giden[this.lastFocusedElement] = suggest.key
            },
            async kampListeleriniOner(search, loading) {
                loading(true)
                await this.kampAra(loading, search, this);
            },
            kampAra: _.debounce(async (loading, search, vm) => {
                vm.kamplar = await kamplariGetir(search)
                loading(false)
            }, 200),
            kampSecildiginde(selected) {
                if (selected == null){
                    return;
                }
                this.kampString = selected.value
                this.giden['KampId'] = selected.key
            },
            async oneriListesiniGetir(alanIsmi) {
                const res = await OtomatikTamamlama("Kart." + alanIsmi, this.giden[alanIsmi])
                return res
            },
            changeFontSize(factor) {
                this.fontSizeFactor += factor;
                setFontSizeFactor(this.fontSizeFactor)
            },
            onElementFocus(ref) {
                this.lastFocusedElement = ref;
            },
            setCaretPosition(ctrl, pos) {
                if (ctrl.setSelectionRange) {
                    ctrl.focus();
                    ctrl.setSelectionRange(pos, pos);

                } else if (ctrl.createTextRange) {
                    var range = ctrl.createTextRange();
                    range.collapse(true);
                    range.moveEnd('character', pos);
                    range.moveStart('character', pos);
                    range.select();
                }
            },
            karakterYaz(karakter) {
                if (this.lastFocusedElement === '')
                    return;

                const ref = document.getElementById(this.lastFocusedElement);
                let strPos = ref.selectionStart;
                let strTop = ref.scrollTop;

                let front = this.giden[this.lastFocusedElement].substring(0, strPos);
                let back = this.giden[this.lastFocusedElement].substring(strPos, ref.value.length);

                this.giden[this.lastFocusedElement] = front + karakter + back;
                ref.value = front + karakter + back

                if (this.$refs[this.lastFocusedElement][0].type !== "textarea")
                    this.$refs[this.lastFocusedElement][0].setText(front + karakter + back)

                strPos = strPos + karakter.length;

                this.$nextTick(() => {
                    this.setCaretPosition(ref, strPos);
                    ref.strTop = strTop
                })
            },
            okunamayanKelimeEkle(aciklama, kesmeDetaylari) {
                okunmayanKelimeEkle("kart", this.gelen.data.Id.deger, aciklama, kesmeDetaylari);
            },
            async Kaydet(e) {
                e.preventDefault();
                
                const arr = this.gelen.data;
                for (let key in arr) {
                    if (arr[key].formdaGoster) {
                        arr[key].deger = this.giden[key]
                    }
                }
                const guncellenmisKart = {
                    data: {
                        ...arr,
                    }
                }
                const key = `kart-${this.gelen.data.Id.deger}`;
                localStorage.setItem(key, JSON.stringify(guncellenmisKart))

                const response = await kartKaydet(this.giden, this.gelen.data.Id.deger, this.tamamlandi);

                if (response.hataVarMi) {
                    this.$notify({
                        group: 'ust',
                        type: 'error',
                        title: 'Hata',
                        text: response.mesaj
                    });
                }
                
                if (response.kod === "kayitedildi") {
                    localStorage.removeItem(key);
                    
                    this.$notify({
                        group: 'ust',
                        title: 'Elhamdülillah',
                        text: response.mesaj
                    });
                }
                if (response.kod === "tamamlandi") {
                    localStorage.removeItem(key);

                    this.$notify({
                        group: 'ust',
                        title: 'Elhamdülillah',
                        text: "Belge Tamamlandı. Yeni belge alabilirsiniz"
                    });
                    setTimeout(async () => {
                        this.$destroy();
                        await this.$router.push("/");
                    }, 3000);
                }
            }
        },
        async mounted() {
            if (!this.girisYapmismi)
                await new GoogleTokenIleGirisYapmayiDene(this);

            if (!this.girisYapmismi) {
                this.gelen.mesaj = "Giriş yapmanız lazım";
                this.gelen.hataVarMi = true;
                setTimeout(() => {
                    this.$router.push("/giris-yap?url=" + encodeURI("/kart"))
                }, 3000);
                return
            }

            const key = `kart-${this.$route.query.id}`;
            if (localStorage.getItem(key)) {
                this.gelen = JSON.parse(localStorage.getItem(key));
            }
            else {
                this.gelen = await kartGetir(this.$route.query.id);
            }

            this.operatorKisiId = this.gelen.data.OperatorKisiId.deger;
            this.editorKisiId = this.gelen.data.EditorKisiId.deger;
            this.tamamlandi = this.gelen.data.Durum.deger === 1;

            if (this.gelen.hataVarMi) {
                if (this.gelen.kod === "giris-yap") {
                    const that = this;
                    setTimeout(function () {
                        that.$router.push("/giris-yap?url=" + encodeURI(that.gelen.data))
                    }, 1000);
                    return
                }
                return;
            }


            const arr = this.gelen.data;
            this.kart = {};
            for (let key in arr) {
                if (arr[key].formdaGoster) {
                    this.kart[key] = arr[key];
                    this.giden[key] = arr[key].deger;
                }
            }

            const kamp = await idyeGoreKampiGetir(arr["KampId"].deger);

            console.log(kamp)
            
            this.$nextTick(() => {
                this.kampString = kamp.isim
                this.giden["KampId"] = kamp.kampId
            });

            this.imgEkstraUrl = kartResmiGetir(this.gelen.data.ResimUrl.deger);

            let val = parseInt(getFontSizeFactor());
            if (isNaN(val))
                val = 0;
            this.changeFontSize(val);


            const kartId = this.gelen.data.Id.deger;
            this.$signalr.on("kartin-bilinmeyenine-cevap-geldi" + kartId, (msj) => {
                this.$notify({
                    group: 'ust',
                    type: 'success',
                    title: 'Sorduğunuz Kelimeye Cevap Geldi',
                    text: msj.metin,
                    duration: 5000
                });
            });
        },
        components: {
            Imla,
            Cropper,
            VueSimpleSuggest,
            vSelect,
            KampTeklifForm
        },
    }
</script>

<style lang="scss">
    .belge-container {
        //background-color: var(--bg-color);    
        
        height: 100%;
        @media (max-width: 500px) {
            height: calc(100% - 120px);
        }
        width: 100%;
        position: relative;
    }

    .form-alani {
        font-family: "Times New Roman", Times, serif;
        position: absolute;
        padding: 10px;
        left: 0;
        height: 100%;
        @media (min-width: 500px) {
            height: 100%;
        }
        width: 50%;
        max-height: inherit;

        @media (max-width: 800px) {
            height: 50%;
            width: 100%;
            bottom: 0px;
        }

        @media all and (device-width: 834px) and (device-height: 1112px) {
            height: 50%;
            width: 100%;
            bottom: 0px;
        }

        #okunamayanlar {
            @media (min-width: 500px) {
                display: none;
            }
        }

        form {
            height: 100%;
            overflow-y: scroll;
            @media (max-width: 500px) {
                margin-top: 0px;
            }
            /*.imla-shortcuts {
                position: fixed;
                top: 60px;
                @media (max-width: 500px) {
                    top: auto;
                }
            }*/
            #formIlkElement {
                @media (max-width: 500px) {
                }
            }
        }

        textarea {
            border: 1px solid #ced4da;
        }
    }

    .mektup-alani {
        position: absolute;
        right: 0px;
        height: 100%;
        width: 50%;
        background-color: #eeeeee;
        @media (max-width: 800px) {
            height: 50%;
            width: 100%;
        }

        @media all and (device-width: 834px) and (device-height: 1112px) {
            height: 50%;
            width: 100%;
        }

    }

    input {
        width: 400px;
        height: 44px;
        padding: 0 16px;
        font-size: 24px;
    }

    .vs__clear { // x çıkmasın.
        display: none;
    }

</style>
